import React from 'react';
import Logo from '../../beatport/svg/LogoV0';

function LogoSection() {
  return (
    <div>
      <Logo width={110} height={27} showLabel={false} style={{ padding: '0px 0px 20px 12px' }} color={'white'} />
    </div>
  )
  // return  <Logo width={90} height={27} showLabel={false} style={{ padding: '0px 0px 0px 12px' }} color={'white'} />
}

export default LogoSection;
